import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminUsersComponent } from './admin-users.component';
import { SharedModule } from '@shared/shared.module';
import { AdminUsersItemComponent } from './components/admin-users-item/admin-users-item.component';
import { AdminUsersInfoComponent } from './components/admin-users-info/admin-users-info.component';
import { AdminUsersEditComponent } from './components/admin-users-edit/admin-users-edit.component';
import { AdminUsersCreateComponent } from './components/admin-users-create/admin-users-create.component';

@NgModule({
    declarations: [
        AdminUsersComponent,
        AdminUsersItemComponent,
        AdminUsersInfoComponent,
        AdminUsersEditComponent,
        AdminUsersCreateComponent
    ],
    exports: [AdminUsersComponent],
    imports: [CommonModule, SharedModule]
})
export class AdminUsersModule {}
